module.exports = __webpack_public_path__ + "static/media/logofacefooter.741c19ef.svg";